module.exports = __webpack_public_path__ + "0850ce4ae5e2d21e8d86b339538eb313.pdf";